import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Constant} from '../util/constant';
import {catchError, retry} from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class SocialHistoryService {
    httpOptions = {headers: new HttpHeaders({'Content-Type': 'application/json'})};

    constructor(private httpClient: HttpClient) {
    };

    deleteByIdSocialHistory(socialHistoryId): Observable<string> {
        return this.httpClient.post<string>(
            Constant.BASE_URL + 'SocialHistory/deleteSocialHistory', {'socialHistoryId': socialHistoryId}, this.httpOptions).pipe(
            retry(3), catchError(Constant.handleError));
    }

    countSocialHistory(socialHistory): Observable<number> {
        return this.httpClient.post<number>(
            Constant.BASE_URL + 'SocialHistory/count', {'socialHistory': socialHistory}, this.httpOptions).pipe(
            retry(3), catchError(Constant.handleError));
    }

    updateSocialHistory(socialHistory, refData): Observable<string> {
        return this.httpClient.post<string>(
            Constant.BASE_URL + 'SocialHistory/updateSocialHistory', [socialHistory, refData], this.httpOptions).pipe(
            retry(3), catchError(Constant.handleError));
    }

    addSocialHistory(socialHistory, refData): Observable<string> {
        return this.httpClient.post<string>(Constant.BASE_URL + 'SocialHistory/addSocialHistory', [socialHistory, refData], this.httpOptions).pipe(
            retry(3), catchError(Constant.handleError));
    }

  addSocialHistoryCpa(socialHistory): Observable<any> {
    console.log('socialHistory', socialHistory);

    return this.httpClient.post<string>(
      Constant.CPA_SPRING_API_URL + 'social-histories', socialHistory, {headers: new HttpHeaders()
          .set('Content-Type', 'application/json'),
        observe: 'response'}).pipe(
      retry(3), catchError(Constant.handleError));
  }

    findAllSocialHistory(socialHistory, pageNo: number, itemsPerPage: number): Observable<string[]> {
        return this.httpClient.post<string[]>(
            Constant.BASE_URL + 'SocialHistory/findAllSocialHistory',
            {'socialHistory': socialHistory, 'pagination': {'pageNo': pageNo, 'itemsPerPage': itemsPerPage}}, this.httpOptions
        ).pipe(
            retry(3), catchError(Constant.handleError));
    }

    findSocialHistoriesByPatientId(patientId: number): Observable<any> {
    return this.httpClient.get<any>(
      Constant.CPA_SPRING_API_URL + 'patients/' + patientId +  '/social-histories', {
        headers: new HttpHeaders()
          .set('Content-Type', 'application/json'),
        observe: 'response'
      }
    ).pipe(
      retry(3), catchError(Constant.handleError));
  }

  findSocialHistoriesByAppointmentId(appointmentId: number): Observable<any> {
    return this.httpClient.get<any>(
      Constant.CPA_CLINICAL_DATA_SERVICE + 'appointments/' + appointmentId +  '/social-histories', {
        headers: new HttpHeaders()
          .set('Content-Type', 'application/json'),
        observe: 'response'
      }
    ).pipe(
      retry(3), catchError(Constant.handleError));
  }




// custom service for global search

    globalSearchCount(searchTerm,appointmentId,expertId,patientId): Observable<number> {
        return this.httpClient.post<number>(
            Constant.BASE_URL + 'SocialHistory/countGlobalSH',
            {'searchTerm': searchTerm,'appointmentId':appointmentId,'expertId':expertId,'patientId':patientId},
            this.httpOptions
        ).pipe(
            retry(3), catchError(Constant.handleError));
    }

    globalSearchFind(searchTerm,appointmentId,expertId,patientId, pageNo: number, itemsPerPage: number): Observable<string[]> {
        return this.httpClient.post<string[]>(
            Constant.BASE_URL + 'SocialHistory/findGlobalSH',
            {'searchTerm': searchTerm,'appointmentId':appointmentId,'expertId':expertId,'patientId':patientId,
                'pagination': {'pageNo': pageNo, 'itemsPerPage': itemsPerPage}},
            this.httpOptions
        ).pipe(
            retry(3), catchError(Constant.handleError));
    }
}
